'use client';
import React from 'react';
import { Carousel } from 'react-bootstrap';
import Image from 'next/image';

interface LogoCarouselProps {
  images: { src: string; blurDataURL: string }[];
}

export default function LogoCarousel({ images }: LogoCarouselProps) {
  return (
    <Carousel
      fade
      controls={false}
      indicators={false}
      aria-roledescription="carousel"
      aria-live="polite"
    >
      {images.map((image, index) => (
        <Carousel.Item key={index}>
          <Image
            src={image.src || '/n_images/default-blog.jpg'}
            alt={`Partner logo ${index + 1}`}
            sizes="(max-width: 767px) 100vw, (max-width: 1200px) 50vw, 30vw"
            width={280}
            height={280}
            placeholder="blur"
            priority
            blurDataURL={image.blurDataURL}
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );
}
